import { FIREBASE_EVENTS } from 'app-constants'

export const EVENTS = {
  UNDUE_PAYMENT_FILE_UPLOAD: {
    SUCCESS: FIREBASE_EVENTS.UNDUE_PAYMENT_SELECT_AND_SEND_FILE_SUCCESS,
    ERROR: FIREBASE_EVENTS.UNDUE_PAYMENT_SELECT_AND_SEND_FILE_ERROR,
    UPLOAD: FIREBASE_EVENTS.UNDUE_PAYMENT_SELECT_AND_SEND_FILE,
  },
  FILE_UPLOAD: {
    SUCCESS: FIREBASE_EVENTS.SEND_FILE_SUCCESS,
    ERROR: FIREBASE_EVENTS.SEND_FILE_ERROR,
    UPLOAD: FIREBASE_EVENTS.CLICK_ON_SELECT_FILE,
  },
}
